import {BUSCAR_CONFIGURACAO_PONTO, LIMPAR_CONFIGURACAO_PONTO } from '../../actions/types'

const initialState = undefined;

export default function reducerAdesaoPontos (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_CONFIGURACAO_PONTO: {
      const adesaoPontos = action.payload.data;

      if (adesaoPontos) {
        return adesaoPontos
      }
      return []
    }

    case LIMPAR_CONFIGURACAO_PONTO:
      return [];

    default: {
      return state
    }
  }
}
